const FILLS = ["open","books","records"];
const FILL_NAME = {open:"Open", books:"Books", records:"Records"};
const FINISHES = {
stainless:{name:"Stainless", sw:"linear-gradient(105deg,#f4f5f3,#c9cbc6 45%,#e8eae7 60%,#a9aca6)"},
powder:   {name:"Powdercoat", sw:"linear-gradient(105deg,#6d6350,#544a27)"},
};
const COLOURS = {
chalk:    {name:"Chalk",     hex:"#e8e4da"},
sand:     {name:"Sand",      hex:"#cbbfa4"},
olive:    {name:"Olive",     hex:"#544a27"},
clay:     {name:"Clay",      hex:"#9c5f45"},
charcoal: {name:"Charcoal",  hex:"#4a4d4f"},
black:    {name:"Black",     hex:"#1c1d1e"},
};
const MINW=200, MAXW=1400;
const MAXSH = 4;
function newBay(f,w){ return {fill:f||"open", door:null, shelves:0, w:w||400}; }
const DOORS = { left:"Hinge left", right:"Hinge right", double:"Double" };
function defaultDoor(b){ return b.w>620 ? "double" : "left"; }
let state = { finish:"stainless", colour:"olive", height:450, depth:450, upstand:15, sel:0,
bays:[newBay("open",300),newBay("open",300),newBay("open",300),newBay("open",300)] };
function total(){ return state.bays.reduce((s,b)=>s+b.w,0); }
function compartH(bay){ const n=(bay.shelves||0)+1; return Math.round((clearH()-(n-1)*2)/n); }
const MINUP = 15;
function baseInset(){ return Math.min(30, state.height*0.06); }
function upstand(){ return Math.max(MINUP, Math.min(state.upstand, state.height - baseInset() - 66)); }
function maxCols(){ return Math.max(1, Math.floor(total()/MINW)); }
function setColumns(n){
n = Math.max(1, Math.min(maxCols(), Math.round(n)));
while(state.bays.length < n){
let i=0; state.bays.forEach((b,k)=>{ if(b.w>state.bays[i].w) i=k; });
if(state.bays[i].w < MINW*2) break;
const b=state.bays[i], half=Math.round(b.w/2/10)*10;
b.w -= half;
state.bays.splice(i+1,0,newBay(b.fill,half));
}
if(state.bays.length < n){
const L=total(), keep=state.bays.slice();
const base=Math.max(MINW, Math.floor(L/n/10)*10);
state.bays = Array.from({length:n},(_,k)=>{
const src=keep[Math.min(k,keep.length-1)], b=newBay(src.fill,base);
b.shelves=src.shelves||0; b.door=src.door; return b;
});
let drift=L-total();
for(const b of state.bays){ if(drift<=0) break;
const take=Math.min(drift, MAXW-b.w); b.w+=take; drift-=take; }
}
while(state.bays.length > n && state.bays.length > 1){
let i=0; state.bays.forEach((b,k)=>{ if(b.w<state.bays[i].w) i=k; });
const gone=state.bays.splice(i,1)[0];
let spill=gone.w;
const order=[state.bays[Math.min(i,state.bays.length-1)], ...state.bays];
for(const b of order){ if(spill<=0) break;
const take=Math.min(spill, MAXW-b.w); b.w+=take; spill-=take; }
}
if(state.sel >= state.bays.length) state.sel = state.bays.length-1;
}
function setUpstand(v){ state.upstand = Math.max(MINUP, Math.min(250, Math.round(v/5)*5)); }
function clearH(){ const H=state.height; return Math.max(60, Math.round(H - upstand() - baseInset() - 6)); }
function setHeight(v){ state.height = Math.max(250, Math.min(1600, Math.round(v/10)*10)); }
function setDepth(v){ state.depth = Math.max(250, Math.min(700, Math.round(v/10)*10)); }
function setBayWidth(i,w){
w = Math.max(MINW, Math.min(MAXW, Math.round(w/10)*10));
const b = state.bays[i];
if(state.bays.length < 2){ b.w = w; return; }
const jn = (i < state.bays.length-1) ? i+1 : i-1;
const nb = state.bays[jn];
const pair = b.w + nb.w;
w = Math.min(w, pair - MINW);
w = Math.max(w, pair - MAXW, MINW);
b.w = w;
nb.w = pair - w;
}
function money(n){ return "$"+n.toLocaleString("en-NZ"); }
const CFG = (window.LG_BUILDER || {}).rates || {};
const n = (v, d) => { const x = typeof v === "string" ? parseFloat(v) : v;
return (typeof x === "number" && isFinite(x) && x > 0) ? x : d; };
const SHEET = { w:2440, h:1220, cost:n(CFG.sheet, 210) };   // 304 brushed 1.5mm, NZ$/sheet
const MATBASIS = (CFG.basis === "sheets") ? "sheets" : "area";
const RATES = {
cut:         n(CFG.cut,         1.60),  // $/m of waterjet cut
bend:        n(CFG.bend,        9),     // $/bend at the brake
rivet:       n(CFG.rivet,       0.35),  // $/rivet
labour:      n(CFG.labour,      85),    // $/hr assembly
powderM2:    n(CFG.powderM2,    45),    // $/m2 coated (both faces)
powderSetup: n(CFG.powderSetup, 120),
splice:      n(CFG.splice,      120),   // extra joint when a part exceeds sheet length
scrap:       n(CFG.scrap,       25),    // % scrap when charging by area used
margin:      n(CFG.margin,      2.22),  // on trade cost
gst:         n(CFG.gst,         1.15)
};
const MAXPART = SHEET.w - 40;                           // longest single piece
function partList(){
const L=total(), D=state.depth, H=state.height, n=state.bays.length, clear=clearH();
const P=[];
const add=(name,w,hh,q,bends)=>P.push({name,w,h:hh,q,bends});
add("End", D+20, H+20, 2, 1);
if(n>1) add("Divider", D+20, H+20, n-1, 3);
add("Back", L+20, H+20, 1, 3);
add("Top", L+40, D+40, 1, 4);
add("Base", L+40, D+40, 1, 4);
state.bays.forEach(b=>{ if(b.shelves) add("Shelf", b.w+40, D+40, b.shelves, 4); });
state.bays.forEach(b=>{
if(!b.door) return;
if(b.door==="double") add("Door", b.w/2+30, clear+30, 2, 4);
else add("Door", b.w+30, clear+30, 1, 4);
});
add("Kick rail", L+20, 130, 2, 2);
return P;
}
function nestSheets(P){
const KERF=6;
const SW=SHEET.w-2*KERF, SH=SHEET.h-2*KERF;
const items=[];
P.forEach(p=>{
let w=Math.max(p.w,p.h), h=Math.min(p.w,p.h);
const cuts = w>MAXPART ? Math.ceil(w/MAXPART) : 1;
for(let i=0;i<p.q;i++) for(let c=0;c<cuts;c++) items.push({w:w/cuts, h});
});
items.sort((a,b)=> b.h-a.h || b.w-a.w);
const sheets=[];
for(const it of items){
let placed=false;
for(const rows of sheets){
for(const r of rows){
if(it.h<=r.h && r.used+KERF+it.w<=SW){ r.used+=KERF+it.w; placed=true; break; }
}
if(placed) break;
const usedH=rows.reduce((t,r)=>t+r.h+KERF,0);
if(usedH+it.h<=SH){ rows.push({h:it.h, used:it.w}); placed=true; break; }
}
if(!placed) sheets.push([{h:it.h, used:it.w}]);
}
return Math.max(1, sheets.length);
}
function sheetPlan(){
const P=partList();
let area=0, cut=0, bends=0, count=0, longest=0, shelves=0;
P.forEach(p=>{
area  += (p.w*p.h)/1e6 * p.q;
cut   += 2*(p.w+p.h)/1000 * p.q;
bends += p.bends*p.q;
count += p.q;
longest = Math.max(longest, p.w, p.h);
if(p.name==="Shelf") shelves += p.q;
});
const sheetArea=(SHEET.w*SHEET.h)/1e6;
const sheets=nestSheets(P);
const spare=sheets*sheetArea-area;
const waste=1-area/(sheets*sheetArea);
const splices = longest>MAXPART ? Math.ceil(longest/MAXPART)-1 : 0;
return {area, cut, bends, count, shelves, sheets, spare, waste, longest, splices};
}
function priceModel(){
const p=sheetPlan();
const rivets=(state.bays.length+1)*8 + p.shelves*8 + 24;
const hours=0.6 + 0.22*p.count + 0.02*rivets;
const perM2=SHEET.cost/((SHEET.w*SHEET.h)/1e6);
const mat = MATBASIS==="sheets" ? p.sheets*SHEET.cost
: p.area*(1+RATES.scrap/100)*perM2;
const cutC=p.cut*RATES.cut;
const bendC=p.bends*RATES.bend + p.splices*RATES.splice;
const hw=rivets*RATES.rivet + 40;
const lab=hours*RATES.labour;
let powder=0;
if(state.finish==="powder") powder=RATES.powderSetup + p.area*2*RATES.powderM2*0.55;
const K=RATES.margin*RATES.gst;
const rows=[
["Steel \u2014 "+p.sheets+" sheet"+(p.sheets>1?"s":"")+" 2440\u00d71220", Math.round(mat*K)],
["Cutting & folding", Math.round((cutC+bendC)*K)],
["Hardware & assembly", Math.round((hw+lab)*K)]
];
if(powder) rows.push(["Powdercoat \u2014 "+COLOURS[state.colour].name, Math.round(powder*K)]);
const tot=Math.round(rows.reduce((s,r)=>s+r[1],0)/10)*10;
return {rows, total:tot, plan:p};
}
const NS="http://www.w3.org/2000/svg";
function el(t,a,p){ const e=document.createElementNS(NS,t); for(const k in a) e.setAttribute(k,a[k]); p.appendChild(e); return e; }
let drag=null;
function draw(){
const svg=document.getElementById("cv"); svg.innerHTML="";
const W=1200,L=total();
const scale=Math.min(940/L,0.55);
const HT=state.height, sV=Math.min(scale, 340/HT);
const uw=L*scale, uh=HT*sV;
const H=Math.round(Math.max(300, uh+215));
svg.setAttribute("viewBox","0 0 "+W+" "+H);
const x0=(W-uw)/2, y1=H-140, y0=y1-uh;
const t=Math.max(1.7,1.5*scale*3.0);
const powder=state.finish==="powder";
const pc = powder ? COLOURS[state.colour].hex : null;
const dim=(hex,f)=>{ const n=parseInt(hex.slice(1),16);
const r=Math.round(((n>>16)&255)*f), g2c=Math.round(((n>>8)&255)*f), b=Math.round((n&255)*f);
return "#"+((1<<24)+(r<<16)+(g2c<<8)+b).toString(16).slice(1); };
const cavFill = powder ? dim(pc,0.62) : "url(#cav)";
const defs=el("defs",{},svg);
defs.innerHTML=`
<linearGradient id="face" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="var(--st1)"/><stop offset=".38" stop-color="var(--st2)"/><stop offset=".72" stop-color="var(--st3)"/><stop offset="1" stop-color="var(--st2)"/></linearGradient>
<linearGradient id="faceV" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="var(--st2)"/><stop offset=".4" stop-color="var(--st1)"/><stop offset=".64" stop-color="var(--st3)"/><stop offset="1" stop-color="var(--st4)"/></linearGradient>
<linearGradient id="cav" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="var(--cav2)"/><stop offset="1" stop-color="var(--cav)"/></linearGradient>
<radialGradient id="pool" cx=".5" cy=".5" r=".5"><stop offset="0" stop-color="#000" stop-opacity=".24"/><stop offset="1" stop-color="#000" stop-opacity="0"/></radialGradient>
<linearGradient id="pcH" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".26"/><stop offset=".5" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".16"/></linearGradient>
<linearGradient id="pcV" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#fff" stop-opacity=".14"/><stop offset=".55" stop-color="#000" stop-opacity=".04"/><stop offset="1" stop-color="#000" stop-opacity=".22"/></linearGradient>
<filter id="brush" x="-2%" y="-2%" width="104%" height="104%">
<feTurbulence type="fractalNoise" baseFrequency="0.9 0.012" numOctaves="2" seed="7" result="n"/>
<feColorMatrix in="n" type="saturate" values="0" result="g"/>
<feComponentTransfer in="g" result="c"><feFuncA type="linear" slope="${powder?0.05:0.15}"/></feComponentTransfer>
<feComposite in="c" in2="SourceGraphic" operator="atop" result="tex"/>
<feBlend in="SourceGraphic" in2="tex" mode="overlay"/></filter>
<filter id="soft" x="-25%" y="-25%" width="150%" height="150%"><feGaussianBlur stdDeviation="10"/></filter>`;
el("rect",{x:0,y:0,width:W,height:H,fill:"var(--white)"},svg);
el("ellipse",{cx:x0+uw/2,cy:y1+14,rx:uw*0.58,ry:22,fill:"url(#pool)",filter:"url(#soft)"},svg);
const g=el("g",{},svg);
const shade=(x,y,w,h,vert)=>{
if(powder){ el("rect",{x,y,width:w,height:h,fill:pc},g);
el("rect",{x,y,width:w,height:h,fill:vert?"url(#pcV)":"url(#pcH)"},g); }
else el("rect",{x,y,width:w,height:h,fill:vert?"url(#faceV)":"url(#face)"},g); };
shade(x0-t*2,y0,t*2,uh,true); shade(x0+uw,y0,t*2,uh,true);
const topY=y0+upstand()*sV, baseY=y1-baseInset()*sV, by=topY+t, bh=baseY-by;
el("rect",{x:x0,y:y0,width:uw,height:topY-y0,fill:cavFill},svg);
el("rect",{x:x0,y:y0,width:uw,height:Math.min(14,(topY-y0)*.55),fill:"#000",opacity:.18},svg);
el("rect",{x:x0,y:baseY,width:uw,height:y1-baseY,fill:cavFill},svg);
shade(x0,y0,uw,t*1.5,false);
el("rect",{x:x0,y:by,width:uw,height:bh,fill:cavFill},svg);
let cx=x0;
state.bays.forEach((bay,i)=>{
const bw=bay.w*scale, gg=el("g",{cursor:"pointer"},svg);
el("rect",{x:cx,y:by,width:bw,height:bh,fill:cavFill},gg);
el("rect",{x:cx,y:by,width:bw,height:Math.min(20,bh*.30),fill:"#000",opacity:.13},gg);
const nsh = bay.shelves||0;
if(nsh>0){
const cellH = (bh - nsh*t)/(nsh+1);
for(let k=0;k<=nsh;k++){
const cy0 = by + k*(cellH+t);
drawContents(gg,bay.fill,cx+3,cy0,bw-6,cellH);
if(k<nsh){
const sy = cy0+cellH;
if(powder){ el("rect",{x:cx,y:sy,width:bw,height:t,fill:pc},gg); el("rect",{x:cx,y:sy,width:bw,height:t,fill:"url(#pcH)"},gg); }
else el("rect",{x:cx,y:sy,width:bw,height:t,fill:"url(#face)"},gg);
}
}
} else drawContents(gg,bay.fill,cx+3,by,bw-6,bh);
if(bay.door){
const leaf=(lx,lw,handleAt)=>{
if(powder){ el("rect",{x:lx,y:by+1,width:lw,height:bh-2,fill:pc},gg); el("rect",{x:lx,y:by+1,width:lw,height:bh-2,fill:"url(#pcV)"},gg); }
else el("rect",{x:lx,y:by+1,width:lw,height:bh-2,fill:"url(#faceV)"},gg);
el("rect",{x:lx,y:by+1,width:lw,height:bh-2,fill:"none",stroke:"var(--edge)","stroke-width":.7,opacity:.5},gg);
el("circle",{cx:handleAt,cy:by+bh/2,r:2.3,fill:"var(--edge)",opacity:.85},gg);
};
if(bay.door==="double"){
const half=(bw-3)/2;
leaf(cx+1, half, cx+half-6);
leaf(cx+2+half, half, cx+4+half+6);
} else if(bay.door==="right"){
leaf(cx+1, bw-2, cx+13);
} else {
leaf(cx+1, bw-2, cx+bw-15);
}
}
if(i===state.sel) el("rect",{x:cx+1.5,y:by+1.5,width:bw-3,height:bh-3,fill:"none",stroke:"var(--olive)","stroke-width":2},gg);
gg.addEventListener("click",()=>{state.sel=i;render();});
cx+=bw;
});
const g2=el("g",{},svg);
const plate=(x,y,w,h)=>{
if(powder){ el("rect",{x,y,width:w,height:h,fill:pc},g2); el("rect",{x,y,width:w,height:h,fill:"url(#pcH)"},g2); }
else el("rect",{x,y,width:w,height:h,fill:"url(#face)"},g2);
el("line",{x1:x,y1:y+h,x2:x+w,y2:y+h,stroke:powder?"#000":"var(--edge)","stroke-width":.5,opacity:powder?.28:.45},g2); };
plate(x0,topY,uw,t*1.6); plate(x0,baseY,uw,t*1.6);
cx=x0;
state.bays.forEach((bay,i)=>{ cx+=bay.w*scale;
if(i<state.bays.length-1){
if(powder){ el("rect",{x:cx-t/2,y:by,width:t,height:bh,fill:pc},g2); el("rect",{x:cx-t/2,y:by,width:t,height:bh,fill:"url(#pcV)"},g2); }
else el("rect",{x:cx-t/2,y:by,width:t,height:bh,fill:"url(#faceV)"},g2);
}});
el("rect",{x:x0+16,y:y1-2,width:uw-32,height:2,fill:"#000",opacity:.22},svg);
cx=x0;
state.bays.forEach((bay,i)=>{ cx+=bay.w*scale;
if(i<state.bays.length-1){
const hit=el("rect",{x:cx-10,y:by,width:20,height:bh,fill:"transparent",cursor:"ew-resize"},svg);
hit.addEventListener("pointerdown",(e)=>{ e.preventDefault();
drag={i,startX:e.clientX,w0:state.bays[i].w,scale}; hit.setPointerCapture(e.pointerId);
state.sel=i; render(); });
}});
const dy=y1+48; cx=x0;
state.bays.forEach((bay,i)=>{
const bw=bay.w*scale, sel=i===state.sel;
el("line",{x1:cx+3,y1:dy,x2:cx+bw-3,y2:dy,stroke:sel?"var(--olive)":"var(--ink2)","stroke-width":sel?1.4:.8,opacity:sel?1:.5},svg);
const lab=el("text",{x:cx+bw/2,y:dy-6,"text-anchor":"middle",fill:sel?"var(--olive)":"var(--ink2)","font-size":"11","font-family":"Helvetica,Arial,sans-serif",opacity:sel?1:.85},svg);
lab.textContent=bay.w; cx+=bw;
});
const vx = x0+uw+t*2+34;
el("line",{x1:vx,y1:y0,x2:vx,y2:y1,stroke:"var(--ink2)","stroke-width":.9},svg);
el("line",{x1:vx-4,y1:y0,x2:vx+4,y2:y0,stroke:"var(--ink2)"},svg);
el("line",{x1:vx-4,y1:y1,x2:vx+4,y2:y1,stroke:"var(--ink2)"},svg);
const vt=el("text",{x:vx+8,y:(y0+y1)/2,fill:"var(--ink2)","font-size":"12","font-family":"Helvetica,Arial,sans-serif","dominant-baseline":"middle"},svg);
vt.textContent=HT+" mm";
const dy2=dy+28;
el("line",{x1:x0,y1:dy2,x2:x0+uw,y2:dy2,stroke:"var(--ink2)","stroke-width":.9},svg);
el("line",{x1:x0,y1:dy2-4,x2:x0,y2:dy2+4,stroke:"var(--ink2)"},svg);
el("line",{x1:x0+uw,y1:dy2-4,x2:x0+uw,y2:dy2+4,stroke:"var(--ink2)"},svg);
const tx=el("text",{x:x0+uw/2,y:dy2+16,"text-anchor":"middle",fill:"var(--ink2)","font-size":"12","font-family":"Helvetica,Arial,sans-serif"},svg);
tx.textContent=L+" mm";
}
function drawContents(g,type,x,y,w,h){
const pad=9;
if(type==="books"){ let bx=x+pad,i=0;
while(bx<x+w-pad-6){ const bh2=h*(0.46+((i*37)%25)/64), bwd=5+((i*13)%8);
el("rect",{x:bx,y:y+h-bh2,width:bwd,height:bh2,rx:.8,fill:"#d3d5d0",opacity:.22+((i*7)%22)/70},g);
bx+=bwd+2.4; i++; } }
else if(type==="records"){ let bx=x+pad,i=0;
while(bx<x+w-pad-4){ el("rect",{x:bx,y:y+h*0.14,width:2.6,height:h*0.82,fill:"#d3d5d0",opacity:.17+((i*11)%16)/70},g); bx+=4.8; i++; } }
}
function render(){
draw();
const bay=state.bays[state.sel];
const mods=document.getElementById("mods"); mods.innerHTML="";
FILLS.forEach(k=>{ const b=document.createElement("button");
b.className = bay.fill===k?"on":""; b.textContent=FILL_NAME[k];
b.addEventListener("click",()=>{bay.fill=k;render();}); mods.appendChild(b); });
const fins=document.getElementById("fins"); fins.innerHTML="";
for(const k in FINISHES){ const f=FINISHES[k], b=document.createElement("button");
b.className="fin"+(state.finish===k?" on":"");
b.innerHTML=`<i style="background:${k==="powder"?COLOURS[state.colour].hex:f.sw}"></i>${f.name}`;
b.addEventListener("click",()=>{state.finish=k;render();}); fins.appendChild(b); }
const cols=document.getElementById("cols"), cn=document.getElementById("colname");
cols.innerHTML="";
if(state.finish==="powder"){
cols.style.display="grid"; cn.style.display="block";
for(const k in COLOURS){ const c=COLOURS[k], b=document.createElement("button");
b.className="col"+(state.colour===k?" on":""); b.style.background=c.hex;
b.title=c.name; b.setAttribute("aria-label","Powdercoat colour "+c.name);
b.addEventListener("click",()=>{state.colour=k;render();}); cols.appendChild(b); }
cn.textContent = COLOURS[state.colour].name + " — or any RAL / Dulux colour to order. Final colour to be determined before manufacturing.";
} else { cols.style.display="none"; cn.style.display="block";
cn.textContent = "Natural 304 stainless, brushed and left raw."; }
const nsh = bay.shelves||0;
document.getElementById("shN").textContent = nsh;
document.getElementById("shelfStep").classList.toggle("on", nsh>0);
document.getElementById("shMinus").disabled = nsh<=0;
document.getElementById("shPlus").disabled = nsh>=MAXSH || compartH(bay)<80;
document.getElementById("togDoor").classList.toggle("on",!!bay.door);
const dt=document.getElementById("doorType");
dt.style.display = bay.door ? "grid" : "none";
dt.innerHTML = Object.keys(DOORS).map(k=>
`<button data-door="${k}" class="${bay.door===k?"on":""}">${DOORS[k]}</button>`).join("");
const bw=document.getElementById("bw"); if(document.activeElement!==bw) bw.value=bay.w;
const bwn=document.getElementById("bwnum"); if(document.activeElement!==bwn) bwn.value=bay.w;
const nc=document.getElementById("ncol");
if(nc){ nc.max=Math.max(2,maxCols()); if(document.activeElement!==nc) nc.value=state.bays.length; }
const ncn=document.getElementById("ncolnum");
if(ncn){ ncn.max=maxCols(); if(document.activeElement!==ncn) ncn.value=state.bays.length; }
const hf=document.getElementById("headfine"); if(hf) hf.textContent="304 stainless · "+state.depth+" deep";
document.getElementById("dims").textContent=total()+" × "+state.depth+" × "+state.height+" mm  ·  bay clear "+clearH()+" mm";
const hs=document.getElementById("hgt"); if(document.activeElement!==hs) hs.value=Math.min(1200,Math.max(300,state.height));
const us=document.getElementById("ups"); if(us && document.activeElement!==us) us.value=Math.min(200,upstand());
const un=document.getElementById("upsnum"); if(un && document.activeElement!==un) un.value=state.upstand;
const unote=document.getElementById("upnote");
if(unote) unote.textContent = upstand()!==state.upstand ? upstand()+" mm — limited by height" : "";
const ds=document.getElementById("dep"); if(ds && document.activeElement!==ds) ds.value=state.depth;
const dn=document.getElementById("depnum"); if(dn && document.activeElement!==dn) dn.value=state.depth;
const hn=document.getElementById("hgtnum"); if(document.activeElement!==hn) hn.value=state.height;
const le=document.getElementById("len"); if(document.activeElement!==le) le.value=Math.min(3200,Math.max(600,total()));
const ln=document.getElementById("lennum"); if(document.activeElement!==ln) ln.value=total();
const {total:tot}=priceModel();
document.getElementById("total").textContent=money(tot);
if(window.LG3D) window.LG3D.update(state, state.finish==="powder" ? COLOURS[state.colour].hex : null, {upstand:upstand(), baseInset:baseInset()});
}
window.addEventListener("pointermove",e=>{ if(!drag) return;
const svg=document.getElementById("cv");
const px=(e.clientX-drag.startX)*(1200/svg.getBoundingClientRect().width);
setBayWidth(drag.i, drag.w0+px/drag.scale); render(); });
window.addEventListener("pointerup",()=>{drag=null;});
function setLength(target){
target = Math.max(600, Math.min(4000, target));
while(state.bays.length > 1 && target < state.bays.length*MINW){
state.bays.pop();
if(state.sel >= state.bays.length) state.sel = state.bays.length-1;
}
const k = target/total();
state.bays.forEach(b=>b.w=Math.max(MINW,Math.round(b.w*k/10)*10));
let drift = target - total();
const order = [...state.bays].sort((a,b)=> drift>0 ? a.w-b.w : b.w-a.w);
for(const b of order){
if(drift === 0) break;
const room = drift>0 ? MAXW-b.w : MINW-b.w;
const take = drift>0 ? Math.min(drift, room) : Math.max(drift, room);
b.w += take; drift -= take;
}
}
let view3d=false;
function setView(on){
if(on && !window.LG3D) return;
view3d=on;
document.querySelector(".stage").classList.toggle("threed",on);
document.getElementById("vElev").classList.toggle("on",!on);
document.getElementById("vThree").classList.toggle("on",on);
document.getElementById("vElev").setAttribute("aria-selected",String(!on));
document.getElementById("vThree").setAttribute("aria-selected",String(on));
document.getElementById("hint").textContent = on
? "Drag to orbit · scroll to zoom · switch to Elevation to resize bays"
: "Drag a divider to resize a bay · click a bay to select it";
if(window.LG3D) window.LG3D.setActive(on);
}
document.getElementById("vElev").addEventListener("click",()=>setView(false));
document.getElementById("vThree").addEventListener("click",()=>setView(true));
function mark3dReady(){ document.querySelector(".views").classList.add("ready"); render(); }
if(window.LG3D) mark3dReady(); else document.addEventListener("lg3dready", mark3dReady, {once:true});
function wire(){
document.getElementById("ups").addEventListener("input",e=>{ setUpstand(+e.target.value); render(); });
document.getElementById("upsnum").addEventListener("input",e=>{ setUpstand(+e.target.value); render(); });
document.getElementById("dep").addEventListener("input",e=>{ setDepth(+e.target.value); render(); });
document.getElementById("depnum").addEventListener("input",e=>{ setDepth(+e.target.value); render(); });
document.getElementById("len").addEventListener("input",e=>{ setLength(+e.target.value); render(); });
document.getElementById("lennum").addEventListener("input",e=>{
const v = parseInt(e.target.value,10);
if(!isNaN(v) && v>=600) { setLength(v); render(); } });
document.getElementById("lennum").addEventListener("blur",e=>{ e.target.value = total(); });
document.getElementById("hgt").addEventListener("input",e=>{ setHeight(+e.target.value); render(); });
document.getElementById("hgtnum").addEventListener("input",e=>{
const v=parseInt(e.target.value,10); if(!isNaN(v)&&v>=250){ setHeight(v); render(); } });
document.getElementById("hgtnum").addEventListener("blur",e=>{ e.target.value=state.height; });
document.getElementById("bw").addEventListener("input",e=>{ setBayWidth(state.sel,+e.target.value); render(); });
document.getElementById("bwnum").addEventListener("input",e=>{
const v = parseInt(e.target.value,10);
if(!isNaN(v) && v>=MINW) { setBayWidth(state.sel,v); render(); } });
document.getElementById("bwnum").addEventListener("blur",e=>{ e.target.value = state.bays[state.sel].w; });
document.getElementById("ncol").addEventListener("input",e=>{ setColumns(+e.target.value); render(); });
document.getElementById("ncolnum").addEventListener("input",e=>{ setColumns(+e.target.value); render(); });
document.getElementById("even").addEventListener("click",()=>{
const L=total(), n=state.bays.length, w=Math.max(MINW,Math.round(L/n/10)*10);
state.bays.forEach(b=>b.w=w); render(); });
document.getElementById("shPlus").addEventListener("click",()=>{
const b=state.bays[state.sel];
if((b.shelves||0)<MAXSH && compartH(b)>=80){ b.shelves=(b.shelves||0)+1; render(); } });
document.getElementById("shMinus").addEventListener("click",()=>{
const b=state.bays[state.sel];
if((b.shelves||0)>0){ b.shelves--; render(); } });
document.getElementById("togDoor").addEventListener("click",()=>{
const b=state.bays[state.sel]; b.door = b.door ? null : defaultDoor(b); render(); });
document.getElementById("doorType").addEventListener("click",e=>{
const k=e.target.dataset.door; if(!k) return;
state.bays[state.sel].door=k; render(); });
document.getElementById("order").addEventListener("click", onOrder);
render();
}
function buildSpec(){

const spec={product:"credenza",grammar:"steven",finish:state.finish,
colour: state.finish==="powder" ? COLOURS[state.colour].name : "natural",length_mm:total(),depth_mm:state.depth,height_mm:state.height,upstand_mm:upstand(),bay_clear_mm:clearH(),
columns:state.bays.length,bays:state.bays.map(b=>({width_mm:b.w,fill:b.fill,door:b.door||false, door_type:b.door?DOORS[b.door]:null,shelves:b.shelves||0,compartment_clear_mm:compartH(b)})),
price_nzd:priceModel().total,sheets:priceModel().plan.sheets,parts_area_m2:+priceModel().plan.area.toFixed(2),generated:"little-graham builder v0.5"};
return spec;
}
function specProperties(spec){
const p={};
p["Length"]=spec.length_mm+" mm"; p["Depth"]=spec.depth_mm+" mm"; p["Height"]=spec.height_mm+" mm";
p["Upstand"]=spec.upstand_mm+" mm";
p["Finish"]=spec.finish==="powder"?("Powdercoat \u2014 "+spec.colour+" (final colour to be confirmed before manufacturing)"):"Natural stainless";
p["Columns"]=String(spec.columns);
p["Sheets"]=String(spec.sheets)+" \u00d7 2440\u00d71220";
spec.bays.forEach((b,i)=>{
const x=[b.shelves?b.shelves+" shelf"+(b.shelves>1?"s":""):null, b.door_type?b.door_type.toLowerCase():null].filter(Boolean).join(", ");
p["Bay "+(i+1)]=b.width_mm+" mm \u00b7 "+b.fill+(x?" \u00b7 "+x:"");
});
p["_spec"]=JSON.stringify(spec);
return p;
}
async function onOrder(e){
const btn=e.currentTarget, spec=buildSpec(), cfg=window.LG_BUILDER||{};
const s=document.getElementById("spec");
if(!cfg.variantId){ s.style.display="block";
s.textContent="Preview mode \u2014 no variant configured.\n\n"+JSON.stringify(spec,null,1); return; }
btn.disabled=true; btn.textContent="Adding\u2026";
try{
const res=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
body:JSON.stringify({items:[{id:cfg.variantId,
quantity:Math.max(1,Math.round(spec.price_nzd/(cfg.unitPrice||1))),
properties:specProperties(spec)}]})});
if(!res.ok) throw new Error(await res.text());
window.location.href="/cart";
}catch(err){ btn.disabled=false; btn.textContent="Request this piece";
s.style.display="block"; s.textContent="Could not add to cart: "+err.message; }
}
if(document.readyState!=='loading') wire(); else document.addEventListener('DOMContentLoaded', wire);
render();